<template>
  <div class="login">
    <div class="login-wrapper">
      <div class="l">
        <div>
          <span>快速创建您的个性化机器人只需四步</span>
          <img src="../../img/icon3.png" alt="" class="img">
        </div>
      </div>
      <div class="r con-wrap">
        <p class="tit">账号登录</p>
        <input type="text" class="name" v-model="name" placeholder="输入用户名/手机号/注册邮箱进行登录" maxlength="50">
        <input type="password" class="pas" v-model="pas"  placeholder="输入密码" maxlength="50" @keyup.enter="checkMsg">
        <div class="wrong" v-show="errorShow">{{errorMsg}}</div>
        <div class="jtocode" v-show="codeshow"></div>
        <div class="login-btn" @click="checkMsg">登录</div>
        <div class="hrefs clearfix">
          <router-link :to="{ name: 'register'}" class="res"><span @click="changeState">立即注册</span></router-link>
          <router-link :to="{ name: 'findPas'}" class="forget"><span @click="forget">忘记密码</span></router-link>
        </div>
        <div class="login-way">使用第三方账号登陆</div>
        <div class="elLogin">
          <a class="el1" href="#" @click="getQQ"></a>
          <a class="el2" href="#" @click="getWEI"></a>
          <a class="el3" href="#" @click="getBO"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mixin from '../../js/public.js';
  import '../../js/geetest.js';
  import $ from 'jquery';

  export default{
      mixins: [mixin],
      props: {
        loginShow: {
          type: Boolean
        }
      },
      data () {
        return {
          name: '',
          pas: '',
          errorMsg: '',
          errorShow: false,
          code: '',
          codeshow: false,
          id: ''
        };
      },
      created () {
        var _this = this;
        this.id = this.uuid();
        $.ajax({
          url: _this.baseUrl + '/geetest/v3',
          type: 'POST',
          dataType: 'json',
          data: {id: _this.id},
          xhrFields: {
            withCredentials: true
          },
          success: function (res) {
            if (res.type === 'success') {
              window.initGeetest({
                gt: res.data.gt,
                challenge: res.data.challenge,
                new_captcha: res.data.new_captcha,
                product: 'popup',
                width: '100%',
                offline: !res.data.success
              }, _this.handlerPopup);
            }
          }
        });
        /* 判断当前页面是否是第三方登录返回，并且是那种登录 */
        this.$nextTick(function () {
          this.code = this.getUrlFn('code');
          var name = this.getUrlFn('name');
          if (this.code && name === 'qq') {
            this.loginQQ();
          } else if (this.code && name === 'wei') {
            this.loginWEI();
          } else if (this.code && name === 'bo') {
            this.loginQQ();
          }
        });
      },
      methods: {
        uuid () {
          function S4 () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          }
          return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
        },
        handlerPopup (captchaObj) {
          var _this = this;
          captchaObj.appendTo('.jtocode');
          captchaObj.onSuccess(function () {
            var validate = captchaObj.getValidate();
            setTimeout(function () {
              _this.codeshow = false;
            }, 1500);
            _this.$http.post(_this.baseUrl + '/login/p/1', {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, username: _this.name, password: _this.pas}, {credentials: true}).then(function (res) {
              if (res.body.type === 'success') {
                window.location = _this.ReturnURl;
              } else if (res.body.code === 30000020) {
                captchaObj.reset();
                _this.errorMsg = '验证不成功';
                _this.errorShow = true;
              } else {
                captchaObj.reset();
                _this.errorMsg = '用户名或者密码错误';
                _this.errorShow = true;
              }
            }, function () {
              captchaObj.reset();
              _this.errorMsg = '网络错误，请稍后重试';
              _this.errorShow = true;
            });
          });
        },
        /* 登录验证用户名密码是否正确 */
        checkMsg () {
          var _this = this;
          /* 登录验证是否需要极验 */
          this.$http.post(_this.baseUrl + '/login/need-verify', {username: _this.name}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              /* 如果需要跳出极验 */
             if (res.body.data === true) {
               _this.codeshow = true;
             } else {
               _this.$http.post(_this.baseUrl + '/login/p/1', {username: _this.name, password: _this.pas}, {credentials: true}).then(function (res) {
                 if (res.body.type === 'success') {
                   window.location = _this.ReturnURl;
                 } else {
                   _this.errorMsg = '用户名或密码错误';
                   _this.errorShow = true;
                 }
               }, function () {
                 _this.errorMsg = '网络错误，请稍后重试';
                 _this.errorShow = true;
               });
             }
            } else {
              _this.errorMsg = '网络错误，请稍后重试';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        },
        /* 获取qq登录跳转地址 */
        getQQ () {
          var _this = this;
          this.$http.post(_this.baseUrl + '/login/p/4', {redirect_uri: location.href.split('?')[0] + '?name=qq'}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              window.location = res.body.redirectUrl;
            } else {
              _this.errorMsg = '第三方接口出现问题，请稍后再试';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        },
        /* 获取微信登录跳转地址 */
        getWEI () {
          var _this = this;
          this.$http.post(_this.baseUrl + '/login/p/3', {redirect_uri: location.href.split('?')[0] + '?name=wei'}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              window.location = res.body.redirectUrl;
            } else {
              _this.errorMsg = '第三方接口出现问题，请稍后再试';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        },
        /* 获取微博登录跳转地址 */
        getBO () {
          var _this = this;
          this.$http.post(_this.baseUrl + '/login/p/2', {redirect_uri: location.href.split('?')[0] + '?name=bo'}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              window.location = res.body.redirectUrl;
            } else {
              _this.errorMsg = '第三方接口出现问题，请稍后再试';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        },
        loginQQ () {
          var _this = this;
          this.$http.post(_this.baseUrl + '/login/callback/4', {code: _this.code, redirect_uri: location.href.split('?')[0] + '?name=qq'}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
               window.location = _this.ReturnURl;
            } else if (res.body.code === 11000001) {
              _this.errorMsg = '第三方登录用户属性缺失，需要注册';
              window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
              _this.errorShow = true;
            } else if (res.body.code === 11100000) {
              _this.errorMsg = '第三方登录用户需要注册';
              window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
              _this.errorShow = true;
            } else {
              _this.errorMsg = '第三方接口出现问题，请稍后再试';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        },
        loginWEI () {
          var _this = this;
          this.$http.post(_this.baseUrl + '/login/callback/3', {code: _this.code}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              window.location = _this.ReturnURl;
            } else if (res.body.code === 11000001) {
              _this.errorMsg = '第三方登录用户属性缺失，需要注册';
              window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
              _this.errorShow = true;
            } else if (res.body.code === 11100000) {
              _this.errorMsg = '第三方登录用户需要注册';
              window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
              _this.errorShow = true;
            } else {
              _this.errorMsg = '第三方接口出现问题，请稍后再试';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        },
        loginBO () {
          var _this = this;
          this.$http.post(_this.baseUrl + '/login/callback/4', {code: _this.code}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              window.location = _this.ReturnURl;
            } else if (res.body.code === 11000001) {
              _this.errorMsg = '第三方登录用户属性缺失，需要注册';
              window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
              _this.errorShow = true;
            } else if (res.body.code === 11100000) {
              _this.errorMsg = '第三方登录用户需要注册';
              window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
              _this.errorShow = true;
            } else {
              _this.errorMsg = '第三方接口出现问题，请稍后再试';
              _this.errorShow = true;
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        },
        changeState () {
          this.$emit('changeState');
        },
        forget () {
          this.$emit('forget');
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  @import '../../css/public.scss';
  .login{position: fixed;left: 0;top: 61px;right: 0;bottom: 0;
    .login-wrapper{width: 1000px;height: 478px;position: absolute;left: 50%;top: 50%;margin-left: -500px;margin-top:-270px;}
    .l{float: left;
      span{display: block; width: 302px;height: 51px;background: url("../../img/icon2.png") no-repeat;line-height: 36px;font-size: 16px;color: #333;text-indent: 23px;margin: 40px 0 0 88px;}
      .img{width: 385px;margin: 54px 0 0 51px; display: block;}
    }
    .r{float:right;}
  }
</style>



// WEBPACK FOOTER //
// login.vue?717c88b6